var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 38,
    viewBox: "0 0 36 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M34.4326 32.7046L29.8001 26.5077V16.8967C29.8001 10.5859 25.0214 5.39094 18.8784 4.71296V1.67335C18.8784 0.920979 18.2671 0.311035 17.5132 0.311035C16.7592 0.311035 16.1479 0.920979 16.1479 1.67335V4.71296C10.0049 5.39097 5.22619 10.5859 5.22619 16.8967V26.5076L0.593704 32.7046C-0.864937 34.6559 0.530551 37.4319 2.97007 37.4319H32.0562C34.4957 37.4319 35.8912 34.6559 34.4326 32.7046Z",
    fill: "#1BA397"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.5c8522fe5fa786a9f24f4f34a86c8c5f.svg";
export { ForwardRef as ReactComponent };